/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import Game from '../Game/Game';
import InjectableComponent from '../Utility/Component/ComponentReference/InjectableComponent';
import ComponentBase from '../Utility/ComponentBase';
import IPlayResultComponent from './Object/IPlayResultComponent';

/** @hidden */
// tslint:disable-next-line:typedef
const ccclass = cc._decorator.ccclass;
/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/**
 * @DEBUG Displays the most recent play result on screen for debug purposes.
 */
@ccclass
export default abstract class PlayResultDisplay extends ComponentBase
{
    // #region Display Properties

    /** @hidden */
    @property({ type: cc.Label, visible: true })
    private _resultDisplay: cc.Label = null;

    /** @hidden */
    @property({ type: [cc.String], visible: true })
    private _keys: string[] = [];

    /** @hidden */
    private _gameRef: InjectableComponent<Game> = new InjectableComponent<Game>();

    // #endregion

    /** @hidden */
    protected setContexts(): void
    {
        this._gameRef.SetContext(Game);
    }

    /** @hidden */
    protected update(dt: number): void
    {
        let playResult: IPlayResultComponent = this._gameRef.Value.CurrentPlayResult;

        if (playResult == null) { return; }
        if (playResult.ResultData == null) { return; }

        if (this._resultDisplay)
        {
            this._resultDisplay.string = JSON.stringify(playResult.ResultData, this._keys, "\t");
        }
    }
}
